import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SidebarHeader from '../../../layout/sidebar_header/sidebar_header.jsx'
import FieldTitle from '../../../form/field_title/field_title.jsx'
import FieldDate from '../../../form/field_date/field_date.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'
import IconButton from '../../../common/icon_button/icon_button.jsx'
import PanelForm from '../../../panel/panel_form/panel_form.jsx'
import FieldText from '../../../form/field_text/field_text.jsx'
import FieldTextArea from '../../../form/field_textarea/field_textarea.jsx'
import FieldNumber from '../../../form/field_number/field_number.jsx'
import SupplierForm from '../supplier_form/supplier_form.jsx'
import FormVatTypeSelect from '../../../../common/form/vat_typeselect/vat_typeselect.jsx'
import DateUtil from '../../../../lib/dateutil.jsx'
import currency from '../../../../lib/currency.jsx'

class SidebarActivity extends Component {
  constructor (props) {
    super(props)

    this.state = {
      supplierOptions: [],
      focusField: ''
    }
  }

  static get propTypes () {
    return {
      showLabelType: PropTypes.bool,
      isQuickbookConnected: PropTypes.bool,
      activity: PropTypes.object,
      quickbookItems: PropTypes.object,
      suppliers: PropTypes.array,
      onCreate: PropTypes.func,
      onChangeField: PropTypes.func,
      onSaveField: PropTypes.func,
      onChangeLabelType: PropTypes.func,
      onSaveLabelType: PropTypes.func,
      onAddSupplier: PropTypes.func,
      onDeleteSupplier: PropTypes.func,
      onAddPurchaseOrder: PropTypes.func,
      onCloseActivity: PropTypes.func,
      onSelectSupplier: PropTypes.func,
      reloadQuickbookItems: PropTypes.func,
      onEditPurchaseOrder: PropTypes.func,
      onDeletePurchaseOrder: PropTypes.func,
      onSearchSupplier: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      showLabelType: false,
      isQuickbookConnected: false,
      activity: null,
      quickbookItems: null,
      suppliers: [],
      onCreate: null,
      onChangeField: null,
      onSaveField: null,
      onChangeLabelType: null,
      onSaveLabelType: null,
      onAddSupplier: null,
      onDeleteSupplier: null,
      onAddPurchaseOrder: null,
      onCloseActivity: null,
      onSelectSupplier: null,
      reloadQuickbookItems: null,
      onEditPurchaseOrder: null,
      onDeletePurchaseOrder: null,
      onSearchSupplier: null
    }
  }

  componentDidMount () {
    this._getSupplierOptions()
  }

  render () {
    return (
      <div className='sidebar-activity'>
        {this._renderHeader()}
        {this._renderFormActivity()}
        {this._renderFormSupplier()}
      </div>
    )
  }

  _renderHeader () {
    return (
      <SidebarHeader
        icon='edit'
        title='projectBudget.sidebarActivity.editActivity'
        onClose={this.props.onCloseActivity}
        showCloseBorder
      />
    )
  }

  _renderFormActivity () {
    const {
      activity,
      showLabelType,
      isQuickbookConnected,
      quickbookItems,
      reloadQuickbookItems
    } = this.props
    const { focusField } = this.state
    const fromDate = activity.fromDate
    const toDate = activity.toDate

    let displayText = '-'
    const displaySubtitle = ''

    if (fromDate && toDate) {
      displayText = `${DateUtil.getDisplayDateWithDay(
        fromDate
      )} - ${DateUtil.getDisplayDateWithDay(toDate)}`
    }

    const displayHoursValue = activity.noHours
    let displayPriceValue = ''
    let displayTotalValue = ''
    let displayMarkupPercentage = ''
    let displayInitialBudget = ''
    let displaySellingPrice = ''

    if (focusField === 'pricePerHour') {
      displayPriceValue = activity.pricePerHour
    } else {
      displayPriceValue = currency.formatSymbol(activity.pricePerHour)
    }

    if (focusField === 'total') {
      displayTotalValue = activity.total
    } else {
      displayTotalValue = currency.formatSymbol(activity.total)
    }

    if (focusField === 'markupPercentage') {
      displayMarkupPercentage = activity.markupPercentage
    } else {
      displayMarkupPercentage = `${activity.markupPercentage} %`
    }

    displayInitialBudget =
      activity.initialBudget === -1 ? activity.total : activity.initialBudget
    if (focusField !== 'initialBudget') {
      displayInitialBudget = currency.formatSymbol(displayInitialBudget)
    }

    if (focusField === 'sellingPrice') {
      displaySellingPrice = activity.sellingPrice
    } else {
      displaySellingPrice = currency.formatSymbol(activity.sellingPrice)
    }

    let icon = ''
    if (currency.getCurrency() === 'USD') {
      icon = 'dollar'
    } else if (currency.getCurrency() === 'GBP') {
      icon = 'pound'
    } else {
      icon = 'euro'
    }

    return (
      <PanelForm>
        {activity.type === 'expense-activity' ? (
          <div className='headerinfo'>
            <IconButton
              icon={icon}
              size='big'
              type='secondary'
              className={`sheaderaction${icon === 'euro' ? '' : ' symbol'}`}
            />
            <div className='cost'>
              <IntlMessage ident='projectBudget.sidebarActivity.cost' />
            </div>
          </div>
        ) : (
          <div className='headerinfo'>
            <IconButton
              icon='timer'
              size='big'
              type='secondary'
              className='sheaderaction timericon'
            />
            <div className='cost'>
              <IntlMessage ident='projectBudget.sidebarActivity.time' />
            </div>
          </div>
        )}
        <div className='panelform-row daterange'>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.dateRange' />
            <FieldDate
              name='daterange'
              startDate={activity.fromDate}
              endDate={activity.toDate}
              displayText={displayText}
              subtitle={displaySubtitle}
            />
          </div>
        </div>
        <div className='panelform-row'>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.activity' />
            <FieldText
              name='title'
              value={activity.title}
              onChange={this._onChangeField.bind(this, 'title')}
              onBlur={this._onSaveField.bind(this, 'title')}
            />
          </div>
        </div>
        <div className='panelform-row'>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.description' />
            <FieldTextArea
              name='description'
              showEdit={false}
              className='text'
              value={activity.description}
              onChange={this._onChangeField.bind(this, 'description')}
              onBlur={this._onSaveField.bind(this, 'description')}
            />
          </div>
        </div>
        <div className='panelform-row'>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.hoursUnits' />
            <FieldText
              name='hoursunits'
              value={displayHoursValue}
              onChange={this._onChangeField.bind(this, 'noHours')}
              onBlur={this._onSaveField.bind(this, 'noHours')}
            />
          </div>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.rate' />
            <FieldNumber
              name='rate'
              value={displayPriceValue}
              onChange={this._onChangeField.bind(this, 'pricePerHour')}
              onBlur={this._onSaveField.bind(this, 'pricePerHour')}
              onFocus={this._onFocusField.bind(this, 'pricePerHour')}
            />
          </div>
        </div>
        <div className='panelform-row'>
          <div className='panelform-col'>
            <FieldTitle title='projectBudget.sidebarActivity.total' />
            <FieldNumber
              name='total'
              value={displayTotalValue}
              onChange={this._onChangeField.bind(this, 'total')}
              onBlur={this._onSaveField.bind(this, 'total')}
              onFocus={this._onFocusField.bind(this, 'total')}
            />
          </div>
        </div>
        <div className='panelform-row'>
          {activity.spentAmount ? (
            <div className='panelform-col'>
              <FieldTitle title='projectBudget.sidebarActivity.initialBudget' />
              <div className='colbudget'>{displayInitialBudget}</div>
            </div>
          ) : (
            <div className='panelform-col'>
              <FieldTitle title='projectBudget.sidebarActivity.initialBudget' />
              <FieldNumber
                name='initialbudget'
                value={displayInitialBudget}
                onChange={this._onChangeField.bind(this, 'initialBudget')}
                onBlur={this._onSaveField.bind(this, 'initialBudget')}
                onFocus={this._onFocusField.bind(this, 'initialBudget')}
              />
            </div>
          )}
        </div>
        {activity.type === 'expense-activity' && (
          <>
            <div className='panelform-row markup'>
              <div className='panelform-col'>
                <FieldTitle title='projectBudget.sidebarActivity.markUp' />
                <FieldText
                  name='markup'
                  value={displayMarkupPercentage}
                  onChange={this._onChangeField.bind(this, 'markupPercentage')}
                  onBlur={this._onSaveField.bind(this, 'markupPercentage')}
                  onFocus={this._onFocusField.bind(this, 'markupPercentage')}
                />
              </div>
            </div>
            <div className='panelform-row'>
              <div className='panelform-col'>
                <FieldTitle title='projectBudget.sidebarActivity.sellingPrice' />
                <FieldNumber
                  name='sellingprice'
                  value={displaySellingPrice}
                  onChange={this._onChangeField.bind(this, 'sellingPrice')}
                  onBlur={this._onSaveField.bind(this, 'sellingPrice')}
                  onFocus={this._onFocusField.bind(this, 'sellingPrice')}
                />
              </div>
            </div>
          </>
        )}
        <div
          className={`panelform-row${isQuickbookConnected ? ' hasaction' : ''}`}
        >
          <div className='panelform-col'>
            {showLabelType && (
              <FormVatTypeSelect
                name='labelType'
                value={activity.labelType}
                onChange={this._onChangeLabelType} // eslint-disable-line react/jsx-handler-names
                onBlur={this._onSaveField.bind(this, 'labelType')}
                isQuickbookConnected={isQuickbookConnected}
                quickbookItems={quickbookItems}
                className='cselect plannerselect'
                classNamePrefix='cselect'
                showReloadOption={false}
              />
            )}
          </div>
          {isQuickbookConnected && (
            <div className='panelform-col colaction'>
              <IconButton
                icon='reset'
                type='secondary'
                size='small'
                className='actionreset'
                canHover
                onClick={reloadQuickbookItems}
              />
            </div>
          )}
        </div>
      </PanelForm>
    )
  }

  _renderFormSupplier () {
    const { activity, suppliers } = this.props

    if (activity.type !== 'expense-activity') {
      return null
    }

    const { supplierOptions } = this.state

    return (
      <div className='suppliercont'>
        <div className='supplierlist'>
          <FieldTitle title='projectBudget.sidebarActivity.supplierTitle' />
          {suppliers.map((supplier, idx) => (
            /* eslint-disable indent */
            <div className='supplier' key={idx}>
              <div className='info'>
                <div className='title'>{supplier.supplierName}</div>
                {!supplier.poNumber &&
                  supplier.expenses &&
                  supplier.expenses.length <= 0 && (
                    <IconButton
                      icon='x'
                      size='small'
                      type='secondary'
                      className='actionclose'
                      canHover
                      onClick={this._onDeleteSupplier.bind(this, supplier)} // eslint-disable-line react/jsx-handler-names
                    />
                  )}
              </div>
              <FieldTitle title='projectBudget.sidebarActivity.purchaseOrderTitle' />
              {supplier.poNumber ? (
                /* eslint-enable indent */
                <div
                  key={supplier.id}
                  className='poinfo'
                  onClick={this._onEditPurchaseOrder.bind(
                    this,
                    supplier.purchaseOrderId
                  )}
                >
                  <div className='title'>{supplier.poNumber}</div>
                  <IconButton
                    icon='attachment'
                    size='normal'
                    type='secondary'
                    className='attachment'
                    canHover
                    target='_blank'
                    href={supplier.downloadUrl}
                  />
                  {supplier.canDeletePo && (
                    <IconButton
                      icon='x'
                      size='small'
                      type='secondary'
                      className='actionclose'
                      canHover
                      onClick={this._onDeletePurchaseOrder.bind(
                        this,
                        supplier.purchaseOrderId
                      )}
                    />
                  )}
                </div>
              ) : (
                <div className='poaction'>
                  <IconButton
                    icon='+'
                    size='small'
                    type='secondary'
                    className='addpurchaseorder'
                    canHover
                    label='projectBudget.sidebarActivity.addPurchaseOrder'
                    alignLabel='right'
                    onClick={this._onAddPurchaseOrder.bind(this, supplier)}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        <FieldTitle title='projectBudget.sidebarActivity.addSupplier' />
        <SupplierForm
          supplierOptions={supplierOptions}
          onSelectSupplier={this._onSelectSupplier.bind(this)}
          onAddSupplier={this._onAddSupplier.bind(this)}
        />
      </div>
    )
  }

  _onChangeLabelType = (option, ev) => {
    this._onChangeField('labelType', option.value, ev)
  }

  _onAddSupplier (supplierName) {
    if (this.props.onAddSupplier) {
      this.props.onAddSupplier(supplierName, () => {
        this._getSupplierOptions()
      })
    }
  }

  _onSelectSupplier (supplier) {
    if (this.props.onSelectSupplier) {
      this.props.onSelectSupplier(supplier, () => {
        this._getSupplierOptions()
      })
    }
  }

  _onDeleteSupplier (supplier) {
    if (this.props.onDeleteSupplier) {
      this.props.onDeleteSupplier(supplier, () => {
        this._getSupplierOptions()
      })
    }
  }

  _onChangeField (name, value, ev) {
    const { activity } = this.props
    if (this.props.onChangeField) {
      this.props.onChangeField(activity.id, name, value, ev)
    }
  }

  _onFocusField (name) {
    this.setState({ focusField: name })
  }

  _onSaveField (name, ev) {
    this.setState({ focusField: '' })

    if (this.props.onSaveField) {
      this.props.onSaveField(name, ev)
    }
  }

  _onEditPurchaseOrder (purchaseOrderId) {
    if (this.props.onEditPurchaseOrder) {
      this.props.onEditPurchaseOrder(purchaseOrderId)
    }
  }

  _onAddPurchaseOrder (supplier) {
    if (this.props.onAddPurchaseOrder) {
      this.props.onAddPurchaseOrder(supplier)
    }
  }

  _onDeletePurchaseOrder = (purchaseOrderId, ev) => {
    ev.preventDefault()
    ev.stopPropagation()

    const { onDeletePurchaseOrder } = this.props

    if (onDeletePurchaseOrder) {
      onDeletePurchaseOrder(purchaseOrderId)
    }
  }

  _getSupplierOptions () {
    const { onSearchSupplier, suppliers } = this.props
    if (onSearchSupplier) {
      const excludeIds = []
      suppliers.forEach(supplier => {
        // excludeIds.push(supplier.contactId);
        excludeIds.push(supplier)
      })

      onSearchSupplier(
        null,
        excludeIds,
        allSuppliers => {
          const supplierOptions = allSuppliers.map(supplier => {
            supplier.label = supplier.supplierName
            supplier.value = supplier.contactId

            return supplier
          })
          this.setState({ supplierOptions, dataDate: new Date() })
        },
        true
      )
    }
  }
}

export default SidebarActivity
